export const terminationCategoryRouteName = {
  index: "terminationCategories.index",
};

export const terminationCategoryRoute = [
  {
    path: "/termination-categories",
    name: terminationCategoryRouteName.index,
    component: () => import("../pages/IndexPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "termination_category",
      breadcrumbs: () => {
        return [{ title: "Termination Category" }];
      },
    },
  },
];
